<template>
<div class="mt-3 mt-sm-5 pt-5">
  <b-container>
    <div class="psiContainer">
        <h1 class="font20 mb-4">Contact Us</h1>
        <div class="row">
          <div class="col-md-4 col-sm-12 iframTab col-xs-12">
            <iframe
              title="Map showing William O'Neil India office location"
              height="400"
              width="100%"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.695803681188!2d77.70358231482221!3d12.991297990842984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11993a08670f%3A0x52d85e2679f9ff69!2sWilliam+O'Neil+India!5e0!3m2!1sen!2sin!4v1505983163548"
              frameborder="0"
              allowfullscreen="allowfullscreen"
              class="mapcontainer"
              style="border: 0px;"
            ></iframe>
          </div>
          <div class="col-md-8 col-sm-12 col-xs-12 addressMob">
            <div class="addcont">
              <table>
                <tr>
                  <td>
                    <div class="icontab">
                      <img
                        src="https://storage.googleapis.com/msindiaprod/img/map-icon.svg"
                        class="img-responsive cont-icon"
                        alt="Location"
                      >
                    </div>
                  </td>
                  <td>
                    <div class="addresscontent">
                      <b class="font-weight500 font16 text-algo">PortfolioSmith is part of William O&#39;Neil India Private Limited with headquarters at</b>
                      <p class="font14  mt-2 text-algo-normal">
                        Akshay Tech Park Unit No. 302, 3rd Floor, Plot 72 & 73 EPIP area Hoodi Village, K R Puram Hobli Whitefield
Bangalore-560066
                      </p>
                      <a id="locateUs" target="_blank" href="https://www.google.com/maps/place/William+O'Neil+India/@12.97967,77.724713,16z/data=!4m6!3m5!1s0x3bae11993a08670f:0x52d85e2679f9ff69!8m2!3d12.9796698!4d77.7247133!16s%2Fg%2F11btwr5m0w" type="button" class="btn btn-primary">Locate Us</a>
                    <br>
                    </div>
                    <!-- <div class="addresscontent">
                      <br>
                      <b class="font-weight500 font16 text-algo">We Have Our Branches at Mumbai location as Well</b>
                      <p class="font14  mt-2 text-algo-normal">
                       Kale Donia Building, William O&#39;Neil India, Redbrick Offices - 1st floor, opposite D-Mart, Sambhaji Nagar,
                       <br>Andheri East, Mumbai, Maharashtra - 400069
                      </p>
                      <a id="locateUs" target="_blank" href="https://www.google.com/maps/place/William+O'Neil+India+Pvt.+Ltd/@19.1134832,72.84684,15z/data=!4m5!3m4!1s0x0:0x6c02d6fc47c2236a!8m2!3d19.1134832!4d72.84684" type="button" class="btn btn-primary">Locate Us</a>
                    </div> -->
                  </td>
                </tr>
              </table>
              <div style="height: 30px;"></div>
              <table>
                <tr>
                  <td class="icontab">
                    <img
                      src="https://storage.googleapis.com/msindiaprod/img/tele-icon.svg"
                      class="img-responsive cont-icon"
                      alt="Contact"
                    >
                  </td>
                  <!--<td class="font14  text-algo-normal">
                    <b class="font-weight500 font16 text-algo">Sales -</b> +91-80-6745 3830 / 831 / 832 (Timings : 9AM - 7PM IST, Mon - Fri )
                    <br>
                    <b class="font-weight500 font16 text-algo">Support -</b> +91-80-6745 3830 / 831 / 832 (Timings : 9AM - 7PM IST, Mon - Fri )
                    <br>
                  </td>-->
				  <td class="font14  text-algo-normal">
                    <b class="font-weight500 font16 text-algo">Telephone - </b> 080-46802222 (Timings : 9AM - 7PM IST, Mon - Fri )
                    <br>
                  </td>
                </tr>
              </table>
              <table>
                <tr>
                  <td class="icontab">
                    <img
                      src="https://storage.googleapis.com/msindiaprod/img/mail-icon.svg"
                      alt="Email"
                      class="img-responsive cont-icon"
                    >
                  </td>
                  <td class="textMail">
                    <b class="font-weight500 font16 text-algo">Sales -</b> <a href="mailto:sales@portfoliosmith.in">sales@portfoliosmith.in</a>
                    <br>
                    <b class="font-weight500 font16 text-algo">Support -</b> <a href="mailto:support@portfoliosmith.in">support@portfoliosmith.in</a>
                    <br>
					<b class="font-weight500 font16 text-algo">Grievances -</b> <a href="mailto:grievance@williamoneilindia.com">grievance@williamoneilindia.com</a>
                    <br>
                    <br>
                                                Compliance Officer:
                                                <br>
                                                Name: Shalini Bose
                                                <br>
                                                Contact No: <a :href="'tel:' + phoneNumber">{{ phoneNumber }}</a>
                                                <br>
                                                Email: <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=compliance@williamoneilindia.com" target="_blank">compliance@williamoneilindia.com</a>  
                                                <br>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
    </div>
  </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phoneNumber: '080-67453807'
    };
  },
  created(){
     window.scrollTo(0, 0);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/contactus.vue